import { render, staticRenderFns } from "./editdistributionLevelConfig.vue?vue&type=template&id=b5c80128&scoped=true&"
import script from "./editdistributionLevelConfig.vue?vue&type=script&lang=js&"
export * from "./editdistributionLevelConfig.vue?vue&type=script&lang=js&"
import style0 from "./editdistributionLevelConfig.vue?vue&type=style&index=0&id=b5c80128&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c80128",
  null
  
)

export default component.exports